import React from 'react';
import Logo from '../../../media/acta_logo_black.png';
import Facebook from '../../../media/facebook.png';
import X from '../../../media/twitter.png';
import Telegram from '../../../media/telegram.png';
import Phone from '../../../media/phone.png';
import Mail from '../../../media/mail.png';
import PEC from '../../../media/pec.png';
import IVA from '../../../media/iva.png';
import { Link } from 'react-router-dom';
import '../css/footer.css';

function Footer() {
  return (
    <footer>
      <div className="footer-wrapper">

        
        <div className="footer-col">
          <img src={Logo} className="footer-logo" alt="logo" />
          <p style={{ marginTop: "20px", marginBottom: "20px", fontWeight: "bold" }}>
            Actainfo s.r.l.
          </p>
          <p style={{ color: "#595959" }}>
            Sede legale: Via Boccaccio 4 <br />Sede operativa: Via patini 5<br />64026 Roseto degli Abruzzi (TE)
          </p>
        </div>

        
        <div className="footer-col">
          <p style={{ color: "#595959" }}>ICT-Transizione Digitale-PNRR-Servizi digitali CLOUD-Privacy GDPR
            Portali WEB-Cybersecurity-AI Intelligenza Artificiale-Conservazione
            Formazione specialistica on line-FAD-Marketing e comunicazione
            Servizi Qualificati Marketplace ACN, Abilitazioni MEPA 2009 e 2017
            Aggregatore SPID Intermediario tecnologico convenzionato AGID P.A. e Imprese</p>
        </div>

        
        <div className="footer-col">
          <div className="footer-links">

            <div className="footer-social">
               <a href="https://www.facebook.com/Actainfo/" target='blank'><img src={Facebook} alt="facebook" /></a>
               <a href="https://x.com/Actainfosas" target='blank'><img src={X} alt="x" /></a>
               <a href="https://t.me/actainfo" target='blank'><img src={Telegram} alt="telegram" /></a>
            </div>

            <a href="https://www.actainfo.it/certificazioni/" target='blank'>Certificazioni</a>
            <Link to="/informativa-privacy">Privacy Policy</Link>
            <Link to="/note-legali">Note Legali</Link>
            <Link to="/cookie-policy">Cookie Policy</Link>
            <a href="https://assistenza.actainfo.it/" target='blank'>Assistenza</a>

          </div>
        </div>

      </div>

      
      <div className="footer-bottom">
        <span>
          <img src={Phone} alt="phone" /> Telefono: +39 085 2010274 - 2194581 - 2015591
        </span>
        <span>
          <img src={Mail} alt="mail" /> Email: info@actainfo.it
        </span>
        <span>
          <img src={PEC} alt="pec" /> PEC: info@actapec.it
        </span>
        <span>
          <img src={IVA} alt="iva" /> P.IVA: 01901750677
        </span>
      </div>
    </footer>
  );
}

export default Footer;